// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QAWwh","tabsBox":"styles_tabsBox__1wa8L","createButton":"styles_createButton__3OO48"};